/** Refetches the session-create QS balances when a session or transfer changes (WCO-2777). */
import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { wsService } from '../services/websocket';

const HOLD_CHANGING_EVENTS = [
  'production-session-created',
  'production-session-updated',
  'hte-transfer-updated',
];

export function useQsInventoryLive(): void {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleHoldChange = () => {
      queryClient.invalidateQueries(['icsBalances']);
    };

    HOLD_CHANGING_EVENTS.forEach(event => wsService.on(event, handleHoldChange));
    return () => {
      HOLD_CHANGING_EVENTS.forEach(event => wsService.off(event, handleHoldChange));
    };
  }, [queryClient]);
}
